import gql from 'graphql-tag';

export default gql`
  mutation adminDeleteSchool($schoolId: ID!) {
    adminDeleteSchool(schoolId: $schoolId)
  }
`;
